import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/connectors")({
  component: ConnectorsLayout,
});

function ConnectorsLayout() {
  return <Outlet />;
}
